import consumer from "./consumer";

document.addEventListener("turbolinks:load", () => {
  const listContainer = document.querySelector(".steps[data-list-id]");
  const listId = listContainer?.dataset.listId;
  const channelName = "TaskChannel";

  if (!listId) {
    console.log("No list_id found, subscription not created.");
    return;
  }

  consumer.subscriptions.create({ channel: "TaskChannel" }, {
    connected() {
      console.log(`Connected to ${channelName}`);
    },

    disconnected() {
      console.log(`Disconnected from ${channelName}`);
    },

    // received(data) {
    //   if (data.action === "update") {
    //     let minimized = data.expanded ? false : true;
    //     let url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${data.id}`;

    //     if (minimized) {
    //       url += "?minimized=true";
    //     }

    //     const globalStatusDiv = document.getElementById("global-task-generation-status");

    //     if (data.pdf === "true") {
    //       globalStatusDiv.textContent = "PDF generated successfully!";
    //       globalStatusDiv.classList.add("block");
    //     } else if (data.pdf === "false") {
    //       globalStatusDiv.textContent = `PDF generation failed: ${data.error || "Unknown error"}`;
    //       globalStatusDiv.classList.add("block", "failed");
    //     }

    //     const loader = document.getElementById("full-page-loader");
    //     const savingMessage = document.getElementById("global-task-generation-status");

    //     if(data.checkbox === true){
    //       if (loader) loader.style.display = "block";
    //       if (savingMessage) {
    //         savingMessage.textContent = "Saving ..."
    //         savingMessage.classList.add("block");;
    //       }
    //     }
    //     setTimeout(() => {
    //       globalStatusDiv.classList.remove("block");
    //     }, 4000);

    //     Rails.ajax({
    //       url: url,
    //       type: "PUT",
    //       dataType: "script",
    //       success: () => {
    //         setTimeout(() => {
    //           if (loader) loader.style.display = "none";
    //           if (savingMessage) savingMessage.classList.remove("block");
    //         }, 1000)
    //       },
    //       error: () => {
    //         if (loader) loader.style.display = "none";
    //         if (savingMessage) savingMessage.classList.remove("block");
    //       }
    //     });
    //   }
    // }

    received(data) {
      const globalStatusDiv = document.getElementById("global-task-generation-status");
      let url;
      let type;

      if (data.action === "get_tasks") {
        url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/render_all_tasks`
        type = "GET"
      } else {
        url = `/${data.account_id}/projects/${data.project_id}/task_lists/${data.task_list_id}/tasks/${data.id}`;
        type = "PUT"
      }

      if (data.pdf === "true") {
        globalStatusDiv.textContent = "PDF generated successfully!";
        globalStatusDiv.classList.add("block");
      } else if (data.pdf === "false") {
        globalStatusDiv.textContent = `PDF generation failed: ${data.error || "Unknown error"}`;
        globalStatusDiv.classList.add("block", "failed");
      }

      setTimeout(() => {
        globalStatusDiv.classList.remove("block");
      }, 4000);

      Rails.ajax({
        url: url,
        type: type,
        dataType: "script"
      });
    }
  });
});
